import { routes } from '@shared/constants/routes'

export const EDSILinks = [
  { href: routes.COMMUNITY.url, label: 'Community' },
  { href: routes.LADDERUP.url, label: 'LadderUp' },
  { href: routes.GRANTS.url, label: 'Grants' },
]

export const DEIBLinks = [
  { href: `${routes.CORPORATE.url}/belonging/people`, label: 'People' },
  {
    href: `${routes.CORPORATE.url}/belonging/erg`,
    label: 'Employee Resource Group',
  },
  { href: routes.COMMUNITY.url, label: 'Community' },
]

export const CareersLinks = [
  { href: `${routes.CORPORATE.url}/careers`, label: 'Careers' },
  { href: `${routes.CORPORATE.url}/careers/benefits`, label: 'Benefits' },
  { href: `${routes.CORPORATE.url}/careers/culture`, label: 'Culture' },
  { href: `${routes.CORPORATE.url}/careers/departments`, label: 'Departments' },
  {
    href: 'https://shipt.wd1.myworkdayjobs.com/Shipt_External/page/836470ac2020100154069a5626720000',
    label: 'Talent Community',
  },
  { href: `${routes.CORPORATE.url}/careers/internships`, label: 'Internships' },
  {
    href: 'https://shipt.wd1.myworkdayjobs.com/Shipt_External',
    label: 'Search Jobs',
  },
]
